import * as yup from 'yup'
import { REGEXP } from 'shared/consts/regExp'

export const linkFormSchema = {
  title: yup.string().required(),
  link: yup.string().matches(REGEXP.HTTPS_URL, 'Enter a valid url')
}
